import ImagesBlogBlogBgWebp from '@/public/images/blog/blogBg.webp';
import ImagesBlogBlogSignUpWebp from '@/public/images/blog/blogSignUp.webp';
import ImagesBlogBlogThumbnailJpeg from '@/public/images/blog/blogThumbnail.jpeg';
import ImagesBlogBlogTopicsWebp from '@/public/images/blog/blogTopics.webp';
import ImagesBlogClockSvg from '@/public/images/blog/clock.svg';
import ImagesBlogSearchSvg from '@/public/images/blog/search.svg';

export {
  ImagesBlogBlogBgWebp,
  ImagesBlogBlogSignUpWebp,
  ImagesBlogBlogThumbnailJpeg,
  ImagesBlogBlogTopicsWebp,
  ImagesBlogClockSvg,
  ImagesBlogSearchSvg,
};
